/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Dropdown from "./dropdown";
import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import { v4 as uuidV4 } from "uuid";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "16px" }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px" }}>
      {children}
    </th>
  );
};
const resourceOption = [
  // {
  //   value: "---Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá",
  //   label: "---Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá",
  //   disabled: true,
  // },
  {
    value: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá (75%)",
    label: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá (75%)",
  },
  {
    value: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá bán trong nước (75%)",
    label: "Thuốc lá điếu, xì gà và các chế phẩm từ thuốc lá bán trong nước (75%)",
  },
  // {
  //   value: "---Rượu",
  //   label: "---Rượu",
  //   disabled: true,
  // },
  {
    value: "Rượu từ 20 độ trở lên",
    label: "Rượu từ 20 độ trở lên",
  },
  {
    value: "Rượu từ 20 độ trở lên nhập khẩu bán ra trong nước (65%)",
    label: "Rượu từ 20 độ trở lên nhập khẩu bán ra trong nước (65%)",
  },
  
];

const DVTOption = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "tấn",
    label: "Tấn",
  },
  {
    value: "lít",
    label: "Lít",
  },
  {
    value: "chai",
    label: "Chai",
  },
  {
    value: "bao",
    label: "Bao",
  },
  {
    value: "cái",
    label: "Cái",
  },
  {
    value: "chiếc",
    label: "Chiếc",
  },
  {
    value: "hộp",
    label: "Hộp",
  },
];

const content = {
  item1: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item2: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item3: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item4: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item5: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
  item6: [
    {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    },
  ],
};
export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(content);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        console.log(item);
        if (item.id.value === id) {
          return { ...item, [name]: { type: item[name]?.type, value } };
        }
        return item;
      }),
    }));
  };

  const addNewRow = (item) => {
    const newIdValue = data[item].length + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      index: {
        value: 1,
        bg: false,
      },
      title: {
        type: "select",
        value: null,
        bg: false,
      },
      DVT: {
        type: "select",
        value: null,
        bg: false,
      },
      amountOfConsumption: {
        //lượng tiêu thụ
        type: "input",
        value: 0,
        bg: false,
      },
      revenue: {
        //doanh thu
        type: "input",
        value: 0,
        bg: false,
      },
      taxTTDB: {
        //gia tinh thuế ttdb
        value: null,
        bg: true,
      },
      tax: {
        //thue suat
        value: 0,
        bg: true,
      },
      taxDeduction: {
        // thue ttdb khau tru
        type: "input",
        value: 0,
        bg: false,
      },
      mandatoryTax: {
        // thue phai nop
        type: "input",
        value: 0,
        bg: true,
      },
      TaxOffset: {
        // (10)
        type: "input",
        value: 0,
        bg: false,
      },
      totalTaxPayable: {
        // (11)
        type: "input",
        value: 0,
        bg: true,
      },
      id: {
        value: uuidV4(),
        bg: true,
      },
    };

    setData((prev) => ({ ...prev, [item]: [...prev[item], newRow] }));
  };

  const handleDelete = (type, index) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item.id.value !== index),
    }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Việt Nam Đồng
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center", width: "20%" }}>Tên loại hàng hóa, dịch vụ</Th>
              <Th style={{ textAlign: "center" }}>Đơn vị tính</Th>
              <Th style={{ textAlign: "center" }}>Số lượng tiêu thụ trong kỳ</Th>
              <Th style={{ textAlign: "center" }}>Doanh thu bán(chưa có thuế GTGT)</Th>
              <Th style={{ textAlign: "center" }}>Giá tính thuế TTĐB</Th>
              <Th style={{ textAlign: "center" }}>Thuế suất(%)</Th>
              <Th style={{ textAlign: "center" }}>Thuế TTĐB được khấu trừ</Th>
              <Th style={{ textAlign: "center" }}>Thuế TTĐB phải nộp</Th>
              <Th style={{ textAlign: "center" }}>
                Bù trừ với thuế TTĐB chưa được khấu trừ của xăng khoảng nguyên liệu dùng để sản
                xuất, pha chế xăng sinh học (nếu có)
              </Th>
              <Th style={{ textAlign: "center" }}>Thuế TTĐB còn phải phải nộp</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9) = (6)x(7)-(8)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)= (9)+(10)</Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa chịu thuế TTĐB
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                1
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa sản xuất trong nước
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item1.length > 0 &&
              data.item1.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item1", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item1"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType="item1"
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item1"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item1"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                2
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa nhập khẩu bán ra trong nước
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item2.length > 0 &&
              data.item2.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item2", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item2"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType="item2"
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item2"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item2"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item3")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Dịch vụ chịu thuế TTĐB
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item3.length > 0 &&
              data.item3.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item3", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item3"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType="item3"
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item3"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item3"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                III
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item4")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa thuộc trường hợp không phải chịu thuế TTĐB
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                A
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item4")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa xuất khẩu
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item4.length > 0 &&
              data.item4.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item4", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item4"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item4"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item4"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                A
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item5")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa bán để xuất khẩu
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item5.length > 0 &&
              data.item5.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item5", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item5"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType="item5"
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item5"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item5"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                className="toggle-button"
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                C
                <div className="button-action">
                  <button type="button" onClick={() => addNewRow("item6")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Hàng hóa gia công để xuất khẩu
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
            {data &&
              data.item6.length > 0 &&
              data.item6.map((row, index) => (
                <tr key={row.index.value + index}>
                  <Td
                    className="toggle-button"
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.index.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {index + 1}
                    <div className="button-action delete">
                      <button type="button" onClick={() => handleDelete("item6", row.id.value)}>
                        Xóa dòng
                      </button>
                    </div>
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.title.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.title.bg ? (
                      row.title.value
                    ) : row.title?.type === "select" ? (
                      <SelectTable
                        rowType="item6"
                        name="resource"
                        id={row.id.value}
                        option={row.title.option ? row.title.option : resourceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      <InputTable
                        rowType="item6"
                        id={row.id.value}
                        name="title"
                        value={row.title.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "select" ? (
                      row.DVT.value
                    ) : (
                      <SelectTable
                        rowType="item6"
                        name="DVT"
                        id={row.id.value}
                        option={DVTOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.amountOfConsumption?.type !== "input" ? (
                      row.amountOfConsumption.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="amountOfConsumption"
                        value={row.amountOfConsumption.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxTTDB.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxTTDB?.type !== "input" ? (
                      row.taxTTDB.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="taxTTDB"
                        value={row.taxTTDB.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.tax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.tax?.type !== "input" ? (
                      row.tax.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="tax"
                        value={row.tax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxDeduction.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxDeduction?.type !== "input" ? (
                      row.taxDeduction.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="taxDeduction"
                        value={row.taxDeduction.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.mandatoryTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mandatoryTax?.type !== "input" ? (
                      row.mandatoryTax.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="mandatoryTax"
                        value={row.mandatoryTax.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.TaxOffset.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.TaxOffset?.type !== "input" ? (
                      row.TaxOffset.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="TaxOffset"
                        value={row.TaxOffset.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.totalTaxPayable.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.totalTaxPayable?.type !== "input" ? (
                      row.totalTaxPayable.value
                    ) : (
                      <InputTable
                        rowType="item6"
                        type={"number"}
                        id={row.id.value}
                        name="totalTaxPayable"
                        value={row.totalTaxPayable.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:(I+II+II)
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  textAlign: "right",

                  background: "#ddeff3",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontSize: "12px",
                }}
              >
                <InputTable type={"number"} value={0} onChange={handleChange} disabled={true} />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type, rowType });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
